<template>
  <div class="pageIntegral">
    <mu-appbar title="BAW记录">
      <div slot="right" class="title-text" @click="open('top')" >
        <p>筛选 </p>    
        <mu-popup position="top" popupClass="pageIntegral-popup" :open="topPopup" @close="close('top')">
          <mu-content-block>
            <div class="popuptitle delivery-type-order">
              <div class="button-title">交易分类</div>
              <div class="button-list">                  
                <mu-flat-button @click="searchTypeChange(0)" label="全部" :class="searchInfo.traceType==0?'demo-flat-button select':'demo-flat-button'"/>
                <mu-flat-button @click="searchTypeChange(1)" label="充值" :class="searchInfo.traceType==1?'demo-flat-button select':'demo-flat-button'"/>
                <mu-flat-button @click="searchTypeChange(2)" label="提现" :class="searchInfo.traceType==2?'demo-flat-button select':'demo-flat-button'"/>
                <mu-flat-button @click="searchTypeChange(3)" label="订单支付" :class="searchInfo.traceType==3?'demo-flat-button select':'demo-flat-button'"/>
                <mu-flat-button @click="searchTypeChange(4)" label="退款" :class="searchInfo.traceType==4?'demo-flat-button select':'demo-flat-button'"/>
                <mu-flat-button @click="searchTypeChange(5)" label="赠送" :class="searchInfo.traceType==4?'demo-flat-button select':'demo-flat-button'"/>
              </div>
            </div>              
          </mu-content-block>
        </mu-popup>      
      </div>
      <mu-icon-button v-on:click="GoHistory" icon=":fa fa-angle-left" slot="left"/>
    </mu-appbar>   
    
    <v-scroll :on-refresh="onRefresh" :on-infinite="onInfinite">
      <div class="gd-content" v-if="!loaded">  
        <dl v-for="bawItem in bawStreamList" :key="bawItem.TraceNo">           
          <router-link :to="'/usercenter/bawDetail?traceNo='+ bawItem.TraceNo">          
          <dd>
            <table>
              <tbody>
                <tr>
                  <td class="first-row" rowspan="2"><img :src="getIconByTraceType(bawItem.TraceType)"></td>
                  <td class="secend-row calcPlus" v-if="bawItem.Operater == '+'">
                    <i>{{bawItem.TraceTypeName&&bawItem.TraceTypeName.length>10?bawItem.TraceTypeName.substr(0,10)+'...':bawItem.TraceTypeName}}</i>
                    {{ bawItem.Operater }}{{bawItem.TraceAmt.toFixed(candyDecimal)}}
                  </td>
                  <td class="secend-row calcMinus" v-if="bawItem.Operater == '-'">
                    <i>{{bawItem.TraceTypeName&&bawItem.TraceTypeName.length>10?bawItem.TraceTypeName.substr(0,10)+'...':bawItem.TraceTypeName}}</i>
                    {{ bawItem.Operater }}{{bawItem.TraceAmt.toFixed(candyDecimal)}}
                  </td>
                </tr>
                <tr>
                  <td class="one-row ">
                    <span class="date">{{bawItem.AddTime.split('T')[0]}}</span>
                    <span class="total">余额：{{bawItem.TotalAmt.toFixed(candyDecimal)}}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </dd>
          </router-link>
        </dl> 
      </div>
    </v-scroll>
    <XR-toast ref="XRtoast"></XR-toast>
    <XR-PageTip ref="XRPageTip"></XR-PageTip>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchInfo:{
        traceType: 0,
        pageIndex: 1,
        pageSize:15
      },
      pageEnd:0,
      num:15,
      loaded: true,
      bawStreamList:[],
      scrollDone:function(){}, 
      topPopup: false
    };
  },
  mounted(){
    this.$postBase(
      this.MOBILE_URL + "/Oauth2/WeChat/wechat.ashx"
      ).then(function(res) {
      if(!res.IsSuccess){
          //ths.$refs.XRtoast.failed(res.Msg, true)
      }else{
          wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: res.Data.AppId, // 必填，公众号的唯一标识
              timestamp: res.Data.TimeStamp, // 必填，生成签名的时间戳
              nonceStr: res.Data.NonceStr, // 必填，生成签名的随机串
              signature: res.Data.Sign, // 必填，签名，见附录1
              jsApiList: [] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
          wx.ready(function () {
              WeixinJSBridge.call('hideOptionMenu');
          });
      }
    });
    this.$refs.XRtoast.load()    
    this.loadMore(true)
  },
  methods: {
    loadMore (isNewSearch) {
      if(isNewSearch){        
        this.searchInfo.pageIndex=1
      }
      else{        
        this.searchInfo.pageIndex++
      }

      var ths = this;   
      ths.$post(
        "/Shop/BawServer/GetBawStreamPage", this.searchInfo
      ).then(function(res) {
        ths.scrollDone()
        ths.loaded = false
        ths.$refs.XRtoast.hide()
        if(!res.IsSuccess){
          if(isNewSearch){            
            ths.bawStreamList = []
          }
        }else{            
          if(isNewSearch){
            ths.bawStreamList =res.Data.List
          }
          else{            
            for(var i = 0; i < res.Data.List.length;i++){   
              ths.bawStreamList.push(res.Data.List[i])
            }
          }
          ths.pageEnd = res.Data.Rows%ths.num!=0? res.Data.Rows/ths.num+1:res.Data.Rows/ths.num
        }
        if(ths.bawStreamList.length==0){
           ths.$refs.XRPageTip.ShowEmpty('暂无数据')
        }else{
          ths.$refs.XRPageTip.initTip()
        }
      });
    },   
    open (position) {
      this[position + 'Popup'] = true
      this.titleIcon = "fa fa-angle-up";
    },
    close (position) {
      this[position + 'Popup'] = false
      this.titleIcon = "fa fa-angle-down";
    },
    searchTypeChange (type) {
        this.searchInfo.traceType = type
        this.loadMore(true)    
        this.close('top')    
    },   
    GoHistory(){
      this.$router.goBack()
    },
    onRefresh(done) {
      //this.getOrderList();
      done() // call done      
    },
    onInfinite(done) {      
      this.scrollDone = done
      if(this.searchInfo.pageIndex+1 > this.pageEnd){
        done()
        this.$refs.XRtoast.failed("已经到最后一页", true)
        return
      }
      this.loadMore(false);     
    },
    getIconByTraceType:function(traceType){
      if(traceType == 1 ){
        return '/static/icon/recharge.png'
      } 
      else if(traceType == 2 ){
        return '/static/icon/withdraw.png'
      }
      else if(traceType == 3 ){
        return '/static/icon/pay.png'
      }
      else if(traceType == 4 ){
        return '/static/icon/refund.png'
      }
      else if(traceType == 5 ){
        return '/static/icon/reward.png'
      }
    },
    getOperater(traceItem){
      if(traceItem.IncomeOrPay == 1){
        return '+'
      }
      else{
        return '-'
      }
    }
  }
};
</script>
<style>
*{
  margin: 0;
  padding: 0;
}
.pageIntegral .yo-scroll{
  background: white;
  top:56px;
}
.pageIntegral .right{
  text-align: center;
  width: 48px;
}
.pageIntegral .mu-appbar{
    position: fixed;
    top: 0;
    z-index: 20180101;
}
.pageIntegral .mu-appbar-title {
    font-size: 16px;
}
.pageIntegral .right .title-text{
    font-size: 16px;
}
.pageIntegral .gd-content{
  background: white;
  overflow: hidden;
  position: relative;
}
    .pageIntegral .gd-content table {
        width:96%;
    }
    .pageIntegral .gd-content table td {
        vertical-align:middle;
    }
        .pageIntegral .gd-content table td.first-row {
            padding-top:5px;
            width:48px;
            line-height:16px;
            text-align: center;
        }
           .pageIntegral  .gd-content table td.first-row img {
                width:28px;                
            }

       .pageIntegral  .gd-content table td.secend-row {
            padding-top:17px;
            line-height:14px;
            text-align:right;
            font-style:normal;
        }
       .pageIntegral  .gd-content table td.secend-row i{
            float:left;
            color:#8F94A1;
            font-style: normal;
        }
        .pageIntegral .gd-content table td.one-row {
            padding-bottom:17px;
            border-bottom:1px solid #F6F6F6;
            line-height:14px;
            color:#CDCDCD;
            font-size:12px;
        }
        .pageIntegral .gd-content table td.one-row .date{
          float: left;
        }
        .pageIntegral .gd-content table td.one-row .total{
          float: right;
        }

           .pageIntegral  .gd-content table td.one-row.last {
                border:none;
            }

.pageIntegral .calcPlus {
    color:red;
}
.pageIntegral .calcMinus {
    color:#59C2A4;
}

.pageIntegral .coin-info {
    padding:5px 0 20px;
    text-align:center;
}
    .pageIntegral .coin-info .balance {
        font-size:24px;
    }
    .pageIntegral .coin-info .balance-title {
        font-size:12px;
        color:#999;
        padding-top:4px;
    }
    
    .pageIntegral-popup {
        width: 100%;
        top:46px;
        height: 260px;
        z-index: 1;
        padding: 20px 0;
    }
    .pageIntegral-popup .popuptitle .title{
        overflow: hidden;
    }
    .pageIntegral-popup .popuptitle .button-title{
      padding: 20px 20px 10px;
    }
    .pageIntegral-popup .popuptitle .title .text{
        float: left; 
        width:20%;
        text-align: center;
        line-height: 24px;
        color:#ccc;
    }
    .pageIntegral-popup .popuptitle .title .line{
        float: left; 
        height: 1px;
        background:#eee;
        width: 80%;
        border: none;
        margin-top: 10px;
    }
    .pageIntegral-popup .popuptitle .demo-flat-button.select{
      color:red;
    }
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/baw/net/bawStream.vue